import { connect } from 'react-redux';
import { endAlert } from 'phoenix2/state/alert/actions';
import { getConfigParameter } from 'phoenix2/state/config-params/selectors';
import { getKeyboardHandlerId } from 'phoenix2/state/appstate/selectors';
import { analyticsHit } from 'phoenix2/state/analytics/actions';
import { getStaticAssetsURL } from 'phoenix2/state/assets/selectors';

import PureAlert from './alert.jsx';

export const mapStateToProps = state => ({
    staticAssetsURL: getStaticAssetsURL(state),
    disableAnimations: getConfigParameter(state, 'disableAnimations'),
    keyboardHandlerId: getKeyboardHandlerId(state),
});

export const mapDispatchToProps = (dispatch, ownProps) => ({
    openAlert: () => {
        // When a new alert opens, dispatch an analytics event
        const alertType = ownProps.alertSpec.get('type') || 'default';
        dispatch(
            analyticsHit('event', {
                eventCategory: 'open alert',
                eventAction: alertType,
                eventLabel: {
                    alert_title: ownProps.alertSpec.get('title') || '',
                },
            }),
        );
    },
    endAlert: result => {
        // When an alert ends, dispatch an analytics event:
        const alertType = ownProps.alertSpec.get('type') || 'default';
        dispatch(
            analyticsHit('event', {
                eventCategory: 'close alert',
                eventAction: alertType,
            }),
        );
        // Close the alert:
        dispatch(endAlert(result));
    },
});

export const connectAlert = connect(mapStateToProps, mapDispatchToProps);

export const Alert = connectAlert(PureAlert);

export default Alert;

Alert.displayName = 'AlertContainer';
